import { OPTIONS, OPTION_VALUES } from "@ipru-common/constants/InputValues";
import { addTax } from "./QuoteCommonFunctions";
import { quoteConstant, shortCodes, SPOUSE_COVER, TENURE } from "@ipru-common/constants/SiteConstants";
import { currencyToWord } from "./CommonFunctions";
import { CI_RATES } from "./CiRates";
import { CI_PPT_FACTORS } from "./CiPptFactor";
import _ from "lodash";

export const getCriticalIllnessPremium = ({ formData }) => {
  const { CI_SA, age, ciMode, gender, tobacco, paymentOption, term } = formData;
  const ciTerm = _.sortBy([parseInt(term), 20])[0];
  const rateKey = `${shortCodes[gender]}_${ciMode}`;
  const termKey = parseInt(ciTerm) - 5;
  const ppt = formData?.PPT <= 20 ? formData?.PPT : 20;
  const baseRate = parseFloat(CI_RATES?.[rateKey]?.[age]?.[termKey]) || 0;
  const pptFactor = parseFloat(CI_PPT_FACTORS?.[ppt]?.[termKey]) || 1;

  let finalPremium = {
    [OPTION_VALUES.PAYMENT_TENURE.MONTHLY]: 0,
    [OPTION_VALUES.PAYMENT_TENURE.HALF_YEARLY]: 0,
    [OPTION_VALUES.PAYMENT_TENURE.YEARLY]: 0,
  };

  if (gender && tobacco && paymentOption && baseRate) {
    // GET CI

    const rate = multiplyAndRound(baseRate, pptFactor);

    if (rate) {
      const ciPremiumYearly = Math.round((rate * CI_SA) / 1000);

      const loadingMonthly = 1 + quoteConstant.ciModalLoading?.[OPTION_VALUES.PAYMENT_TENURE.MONTHLY];

      const ciMonthly = Math.ceil((ciPremiumYearly * loadingMonthly) / TENURE.MONTHLY);

      const loadingHealfYearly = 1 + quoteConstant.ciModalLoading?.[OPTION_VALUES.PAYMENT_TENURE.HALF_YEARLY];
      const ciHalfYearly = Math.ceil((ciPremiumYearly * loadingHealfYearly) / TENURE.HALF_YEARLY);

      finalPremium = {
        [OPTION_VALUES.PAYMENT_TENURE.MONTHLY]: addTax(ciMonthly),
        [OPTION_VALUES.PAYMENT_TENURE.HALF_YEARLY]: addTax(ciHalfYearly),
        [OPTION_VALUES.PAYMENT_TENURE.YEARLY]: addTax(ciPremiumYearly),
      };
    }
  }
  return finalPremium;
};

function multiplyAndRound(val1, val2) {
  const result = val1 * val2;
  return parseFloat(result.toFixed(4));
}

export const criticalIllnessCoverDropdown = (lumpSumAmt, isHouseWife, quoteId = false) => {
  const fixOption = isHouseWife ? OPTIONS.HOUSEWIFE_CI_LIFE_COVER_OPTIONS : OPTIONS.CI_LIFE_COVER_OPTIONS;

  const maxAllowed = Math.min(lumpSumAmt, 15000000);

  let options = fixOption
    .filter((num) => num <= maxAllowed)
    .map((num) => ({
      id: num,
      name: currencyToWord(num),
    }));

  if (quoteId === SPOUSE_COVER && 500000 <= maxAllowed) {
    options = [{ id: 500000, name: currencyToWord(500000) }, ...options];
  }

  return options;
};
